import DashboardIcon from '@mui/icons-material/Dashboard'
import InsightsIcon from '@mui/icons-material/Insights'
import MapIcon from '@mui/icons-material/Map'
import PeopleIcon from '@mui/icons-material/People'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import SchoolIcon from '@mui/icons-material/School'
import StarsIcon from '@mui/icons-material/Stars'
import { isPointsManagementOpen } from '@/lib/country/entityCountries'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { routeFrontOfficeSchoolRankingCommonUser } from '@/lib/routes/front/common/routeFrontOfficeSchoolRankingCommonUser'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'
import { CountryEnum } from '@/types/enum/enumUser'

const getBackOfficeSchoolAdmin = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord',
    t: 'routes.backoffice.school.dashboard',
    icon: DashboardIcon,
    href: '/backoffice/school/dashboard',
    home: true,
    menuHeader: true,
    position: 10,
  },
  {
    route: 'MyTrainings',
    t: 'routes.backoffice.school.admin.trainings',
    text: 'Les formations',
    icon: SchoolIcon,
    href: '/backoffice/school/my-trainings',
    menuHeader: true,
    position: 40,
  },
  {
    // France et Belgique dans un module ouvert à plusieurs pays (cf. country-scope-front.md).
    route: 'SchoolAnalytics',
    text: 'Analyse des formations',
    t: 'routes.backoffice.school.analytics',
    icon: InsightsIcon,
    href: '/backoffice/school/analytics',
    menuHeader: true,
    position: 45,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE, CountryEnum.BELGIUM].includes(country)
      ),
  },
  {
    // Carte des pharmacies avec les filtres « Actif School » : le pays se choisit sur la page.
    route: 'SchoolPharmacyMap',
    text: 'Carte des pharmacies',
    t: 'routes.backoffice.school.pharmacyMap',
    icon: MapIcon,
    href: '/backoffice/school/maps',
    menuHeader: true,
    position: 47,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE, CountryEnum.BELGIUM, CountryEnum.LUXEMBOURG].includes(country)
      ),
  },
  {
    route: 'Participants',
    text: 'Les participants',
    t: 'routes.backoffice.school.industry.participants',
    icon: PeopleIcon,
    href: '/backoffice/school/participants',
    menuHeader: true,
    position: 50,
  },
  {
    route: 'AskAccessRequests',
    text: "Demandes d'accès",
    t: 'routes.backoffice.school.industry.askAccess',
    icon: PersonAddIcon,
    href: '/backoffice/school/ask-access',
    menuHeader: true,
    position: 55,
  },
  {
    // Réattribuer des points expirés relève de la gestion School (#791). Les super admins
    // gardent l'entrée : ils portent tous le rôle dynamique School. L'API borne la liste et les
    // crédits aux pays du compte.
    route: 'pointsUser',
    menuGroup: MENU_GROUPS.MONITORING,
    text: 'Gestion des points',
    t: 'routes.backoffice.school.admin.pointsUser',
    icon: StarsIcon,
    href: '/backoffice/group/points-user',
    menuHeader: true,
    position: 300,
    fnDisplay: ({ dataMyProfile }) => isPointsManagementOpen(dataMyProfile?.countries),
  },
  {
    route: 'TrainingEdit',
    text: "Edition d'une formation",
    href: '/backoffice/school/trainings/[trainingId]',
  },
  {
    route: 'MyProfile',
    text: 'Mon profil',
    href: '/backoffice/common/my-profile',
    menuHeader: false,
  },
  ...routeBackOfficeAllEntityAdminCommon,
  ...routeFrontOfficeSchoolRankingCommonUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISCHOOL],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_ADMIN],
}))

export default getBackOfficeSchoolAdmin
